import ReportsClient from "@api/reports";
import { APIDateFormat } from "@helpers/dates";
import moment from "moment";
import React from "react";
import { Button, Form, Header, Segment } from "semantic-ui-react";
import ReportsDatepicker from "./ReportsDatepicker";
import ReportsDropdown from "./ReportsDropdown";

class FormBuilder extends React.Component {
  state = {
    fields: {},
    loading: false,
    error: null,
  };

  handleChange = (name, value) => {
    this.setState(
      { fields: { ...this.state.fields, ...{ [name]: value } } },
      () => {
        this.props.onChange(this.props.report, this.prepareParams());
      },
    );
  };

  isValid = () => {
    if (this.state.loading) {
      return false;
    }

    const required = this.props.report.data
      .filter((x) => x.isRequired)
      .map((x) => x.text);

    for (const field of required) {
      if (!this.state.fields[field]) {
        return false;
      }
    }

    return true;
  };

  prepareParams = () => {
    return this.props.report.data.map((item) => {
      return this.state.fields[item.text]
        ? moment.isMoment(this.state.fields[item.text])
          ? this.state.fields[item.text].format(APIDateFormat)
          : this.state.fields[item.text]
        : "#";
    });
  };

  componentDidUpdate = (nextProps) => {
    if (this.props.report.id !== nextProps.report.id) {
      this.setDefaultValues();
    }
  };

  componentDidMount = () => {
    this.setDefaultValues();
  };

  setDefaultValues = () => {
    const fields = {};

    for (const item of this.props.report.data) {
      switch (item.type) {
        case 1:
          fields[item.text] = item.defaultList ? item.defaultList.id : null;
          break;
        default:
          fields[item.text] =
            item.defaultDate !== "0001-01-01T00:00:00"
              ? moment(item.defaultDate).format(APIDateFormat)
              : null;
          break;
      }
    }

    this.setState({ fields });
  };

  handleProcessReport = () => {
    this.props.onError(null, () => {
      this.setState({ loading: true }, () => {
        ReportsClient.createReport(
          this.props.report.name,
          this.props.report.id,
          this.state.fields,
        )
          .then(() => {
            this.setState({ loading: false });
          })
          .catch((error) => {
            let decoder = new TextDecoder("utf-8");
            this.props.onError(decoder.decode(error.response.data));
            this.setState({ loading: false });
          });
      });
    });
  };

  render() {
    const isValid = this.isValid();
    return (
      <Segment.Group>
        <Segment>
          <Header>
            {this.props.report.name}
            {this.props.report.description && (
              <Header.Subheader>
                {this.props.report.description}
              </Header.Subheader>
            )}
          </Header>
        </Segment>
        <Segment>
          <Form className="formbuilder">
            {this.props.report.data.map((item, index) => {
              switch (item.type) {
                case 1:
                  return (
                    <ReportsDropdown
                      index={index}
                      text={item.text}
                      isRequired={item.isRequired}
                      value={this.state.fields[item.text]}
                      options={item.data}
                      onChange={this.handleChange}
                    />
                  );

                default:
                  return (
                    <ReportsDatepicker
                      isRequired={item.isRequired}
                      index={index}
                      text={item.text}
                      value={this.state.fields[item.text]}
                      onChange={this.handleChange}
                    />
                  );
              }
            })}
            <Button
              loading={this.state.loading}
              color="blue"
              className="btn process"
              disabled={!isValid}
              onClick={this.handleProcessReport}
              content="Process Report"
            />
          </Form>
        </Segment>
      </Segment.Group>
    );
  }
}

export default FormBuilder;
